import { render, staticRenderFns } from "./ModalSolicitacaoAluno.vue?vue&type=template&id=4e4f8558"
import script from "./ModalSolicitacaoAluno.vue?vue&type=script&lang=js"
export * from "./ModalSolicitacaoAluno.vue?vue&type=script&lang=js"
import style0 from "./ModalSolicitacaoAluno.vue?vue&type=style&index=0&id=4e4f8558&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports